<ng-container *ngIf="isPublicPath$ | async; else authApp">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #authApp>
  <router-outlet></router-outlet>
  <app-snackbar></app-snackbar>
</ng-template>
